<template>
    <div class="list">
        <div class="userSetting">

        <h1 class="topTitle">管理者管理</h1>
        <span @click="typeChange">　　{{ type }}へ移動</span>

        <div class="container" v-if="type=='ユーザー作成'">
            <div class="outer-menu">
                <input class="checkbox-toggle" v-model="isShowSerchBox" type="checkbox" />
                <div class="hamburger" :class="{ searchIcon: !isShowSerchBox}" @click="isShowSerchBox = !isShowSerchBox">
                    <div v-if="isShowSerchBox"></div>
                </div>
                <div class="menu">
                    <div class="searchArea">
                        <div class="searchBox">
                            <h2 class="itemTitle">検索</h2> 
                            <ul>
                            <li>
                                <label for="name">セラーID:</label>
                                <input type="text" placeholder="セラーID" id="seller_id" v-model="serchItem.seller_id" tabindex="1"/>
                            </li>
                        </ul>
                        <div class="btnBox">
                            <button class="btn" @click="isShowSerchBox = !isShowSerchBox, clear()">クリア</button>
                            <button class="btn" @click="isShowSerchBox = !isShowSerchBox, serch()">検索</button>
                        </div>
                        </div>
                    </div>
                </div>
            </div>
            
            <div class="item-wrap">
                <table class="itemTable">
                    <tr>
                        <th class="listTitle">
                            ユーザーID
                        </th>
                        <th class="listTitle">
                            セラーID
                        </th>
                    </tr>
                    <tr v-for="(item, index) in getItems2" :key="index" >
                        <td class="listItem center imgF">
                            {{item.USER_ID}}
                        </td>
                        <td class="listItem">
                            {{item.SELLER_ID}}
                        </td>
                    </tr>
                    <div class="none">
                    <input type="text" v-model="tmpLogin">
                </div>
                </table>
                
            </div>
            <div class="pdgTop10">
                    <vuejs-paginate
                    :page-count="getPaginateCount2"
                    :prev-text="'<'"
                    :next-text="'>'"
                    :click-handler="paginateClickCallback2"
                    :container-class="'pagination justify-content-center'"
                    :page-class="'page-item'"
                    :page-link-class="'page-link'"
                    :prev-class="'page-item'"
                    :prev-link-class="'page-link'"
                    :next-class="'page-item'"
                    :next-link-class="'page-link'"
                    :first-last-button="true"
                    :first-button-text="'<<'"
                    :last-button-text="'>>'"
                    ></vuejs-paginate>
                </div>
            <div class="btnBox subArea">
                <button class="btn repage" @click="returnPage">戻る</button>
            </div>
        </div>




        <div class="container" v-if="type=='セラーID一覧'">
            <div class="outer-menu">
                <input class="checkbox-toggle" v-model="isShowSerchBox" type="checkbox" />
                <div class="hamburger" :class="{ searchIcon: !isShowSerchBox}" @click="isShowSerchBox = !isShowSerchBox">
                    <div v-if="isShowSerchBox"></div>
                </div>
                <div class="menu">
                    <div class="searchArea">
                        <div class="searchBox">
                            <h2 class="itemTitle">検索</h2> 
                            <ul>
                            <li>
                                <label for="name">ユーザー名:</label>
                                <input type="text" placeholder="ユーザー名" id="name" v-model="serchItem.name" tabindex="1"/>
                            </li>
                            <li>
                                <label for="id">ユーザーID:</label>
                                <input type="text" placeholder="ユーザーID" id="id" v-model="serchItem.id" tabindex="1"/>
                            </li>
                        </ul>
                        <div class="btnBox">
                            <button class="btn" @click="isShowSerchBox = !isShowSerchBox, clear()">クリア</button>
                            <button class="btn" @click="isShowSerchBox = !isShowSerchBox, serch()">検索</button>
                        </div>
                        </div>
                    </div>
                </div>
            </div>
            
            <div class="item-wrap">
                <table class="itemTable">
                    <tr>
                        <th class="listTitle">
                            ユーザー名
                        </th>
                        <th class="listTitle">
                            パスワード
                        </th>
                        <th class="listTitle">
                            子契約数
                        </th>
                        <th class="listTitle">
                            チャットワークROOM ID
                        </th>
                        <th class="listTitle">
                            子契約接続数
                        </th>
                        <th class="listTitle">
                            最大出品数
                        </th>
                        <th class="listTitle">
                            ログイン設定
                        </th>
                        <th class="listTitle">
                            変更
                        </th>
                    </tr>
                    <tr v-for="(item, index) in getItems" :key="index" >
                        <td class="listItem center imgF">
                            {{item.USER_NAME}}
                        </td>
                        <td class="listItem">
                            <div class='validErrMsg' v-for="(err) in $v.tmpUserList.$each[index + ((currentPage -1) *  perPage)].tmpPassword.errMsg" :key="err">{{ err }}</div>
                            <input type="text" v-model="item.tmpPassword" placeholder="初期化の際に入力" @input="valid($v.tmpUserList.$each[index + ((currentPage -1) *  perPage)].tmpPassword, 'パスワード')">
                        </td>
                        <td class="listItem">
                            <div class='validErrMsg' v-for="(err) in $v.tmpUserList.$each[index + ((currentPage -1) *  perPage)].CHILD_NUM.errMsg" :key="err">{{ err }}</div>
                            <input type="number" v-model="item.CHILD_NUM" @input="valid($v.tmpUserList.$each[index + ((currentPage -1) *  perPage)].CHILD_NUM, '子契約数')"><p class="unit">人</p>
                        </td>
                        
                        <td class="listItem">
                            
                            <input type="text" v-model="item.ROOM_ID" >
                        </td>
                        <td class="listItem">
                            {{item.CONNECT_NUM}}<p class="unit">人</p>
                        </td>
                        <td class="listItem">
                            
                            <button class="btn remove" @click="isModal2 = !isModal2,loginOpen(item)">メルカリ</button>
                        </td>
                        <td class="listItem">
                            <input type="number" v-model="item.MAX_SELE_NUM"><p class="unit">商品</p>
                        </td>
                        <td class="listItem">
                            <div class="remBox"><span class="remText">この行のユーザーが<br>削除されます</span><button class="btn remove" @click="remove(item)">削除</button></div>
                            <div v-if="!item.USER_ID.includes('@@@')" class="stpBox"><span class="stpText">この行のユーザーが<br>ツールから出品されなくなります。</span><button class="btn remove" @click="stop(item)">停止</button></div>
                            <div v-if="item.USER_ID.includes('@@@')" class="rstBox"><span class="rstText">この行のユーザーが<br>ツールから出品を再開します。</span><button class="btn remove" @click="restart(item)">再開</button></div>
                            <div class="updBox"><span class="updText">この行のユーザーを<br>左の内容に更新します</span><button class="btn upd" @click="change(index + ((currentPage -1) *  perPage))">更新</button></div>
                        </td>
                    </tr>
                    <div class="none">
                    <input type="text" v-model="tmpLogin">
                </div>
                </table>
                
                <button class="btn" @click="isModal = !isModal">新規ユーザー追加</button>
                
                
            </div>
            <div class="pdgTop10">
                    <vuejs-paginate
                    :page-count="getPaginateCount"
                    :prev-text="'<'"
                    :next-text="'>'"
                    :click-handler="paginateClickCallback"
                    :container-class="'pagination justify-content-center'"
                    :page-class="'page-item'"
                    :page-link-class="'page-link'"
                    :prev-class="'page-item'"
                    :prev-link-class="'page-link'"
                    :next-class="'page-item'"
                    :next-link-class="'page-link'"
                    :first-last-button="true"
                    :first-button-text="'<<'"
                    :last-button-text="'>>'"
                    ></vuejs-paginate>
                </div>
                <div class="overlay" v-show="isModal">
                    <div class="createModal">
                    <div class="swal2-popup swal2-modal swal2-show" style="display: grid;" >
                        <div class="createUser">
                            <div class="login_form_top">
                                <h1 class="title">ユーザー作成</h1>
                            </div>
                            <div class="formBox">
                                <h2 id="userName" class="itemLabel">名前</h2>
                                <div class='validErrMsg' v-for="(err) in $v.postItem.USER_NAME.errMsg" :key="err">{{ err }}</div>
                                <input type="text" v-model="postItem.USER_NAME" @input="valid($v.postItem.USER_NAME, 'ユーザー名')">
                                <h2 id="userId" class="itemLabel">ユーザーID</h2>
                                <div class='validErrMsg' v-for="(err) in $v.postItem.USER_ID.errMsg" :key="err">{{ err }}</div>
                                <input type="text" v-model="postItem.USER_ID" @input="valid($v.postItem.USER_ID, 'ユーザーID')">
                                <h2 id="password" class="itemLabel">パスワード</h2>
                                <div class='validErrMsg' v-for="(err) in $v.postItem.PASSWORD.errMsg" :key="err">{{ err }}</div>
                                <input type="password" v-model="postItem.PASSWORD" @input="valid($v.postItem.PASSWORD, 'パスワード')">
                                <h2 id="childNum" class="itemLabel">子契約数</h2>
                                <div class='validErrMsg' v-for="(err) in $v.postItem.CHILD_NUM.errMsg" :key="err">{{ err }}</div>
                                <input type="text" v-model="postItem.CHILD_NUM" @input="valid($v.postItem.CHILD_NUM, '管理契約数')">
                                <h2 id="roomId" class="itemLabel">チャットワークROOM ID</h2>
                                <!-- <div class='validErrMsg' v-for="(err) in $v.postItem.ROOM_ID.errMsg" :key="err">{{ err }}</div> -->
                                <input type="text" v-model="postItem.ROOM_ID">
                                
                                <div class="none">
                                    <input type="text" v-model="tmpLogin">
                                </div>
                            <div class="btnBox">
                                <button class="btn repage"  @click="isModal = !isModal">キャンセル</button>
                                <button class="btn"  @click="create">作成</button>
                            </div>
                            </div>
                        </div>
                    </div>
                    </div>
                </div>

                <div class="overlay" v-show="isModal2">
                    <div class="createModal">
                    <div class="swal2-popup swal2-modal swal2-show" style="display: grid;" >
                        <div class="createUser">
                            <div class="login_form_top">
                                <h1 class="title">メルカリログイン設定</h1>
                            </div>
                            <div class="formBox">
                                <h2 id="userName" class="itemLabel">ユーザー</h2>
                                <select class="sltBox" v-model="postItem2.USER_ID" @change="getLoginInfo">
                                    <option value="" disabled selected hidden>選択してください</option>
                                    <option v-for="item in loginSetUserList" :value="item.USER_ID" :key="item.USER_ID">
                                        {{ item.USER_NAME }}
                                    </option>
                                </select>
                                <h2 id="userId" class="itemLabel">セラーID</h2>
                                <input type="text" v-model="postItem2.SELLER_ID">
                                <h2 id="password" class="itemLabel">アクセストークン</h2>
                                <input type="text" v-model="postItem2.AUTH_TOKEN">
                                <h2 id="childNum" class="itemLabel">リフレッシュトークン</h2>
                                <input type="text" v-model="postItem2.REF_TOKEN">
                                <h2 id="roomId" class="itemLabel">uuid</h2>
                                <input type="text" v-model="postItem2.UUID">
                                <h2 id="roomId" class="itemLabel">expiration_date</h2>
                                <input type="text" v-model="postItem2.EXPIRATION_DATE">
                            <div class="btnBox">
                                <button class="btn repage"  @click="isModal2 = !isModal2">キャンセル</button>
                                <button class="btn"  @click="loginSet">作成</button>
                            </div>
                            </div>
                        </div>
                    </div>
                    </div>
                </div>
            <div class="btnBox subArea">
                <button class="btn repage" @click="returnPage">戻る</button>
            </div>
        </div>
    </div>
    </div>
</template>
<script>

import {userRepository} from '@/Repositories/userRepository.js'
import {mLoginRepository} from '@/Repositories/mLoginRepository.js'
import VueJsPaginate from "vuejs-paginate";
import check from '@/common/commonCheck';
import { required, maxLength, maxValue, minValue, helpers} from "vuelidate/lib/validators";
export default {
    
  data() {
        return {
            isShowSerchBox:false,
            userInfo:{},
            userList:[],

            tmpUserList:[],

            loginSetUserList:[],
            tmpLogin:'',
            tmp:'',
            serchItem : {
                name:null,
            },
            isModal:false,
            isModal2:false,
            postItem:{
                USER_ID:'',
                USER_NAME:'',
                PASSWORD:'',
                DEL_FLG: 0,
                PAUSE_FLG: 0,
                ROLE:1,
                MAX_SELE_NUM:0,
                SALE_TIME:0,
                PAUSE_TIME:0,
                PROXY_IP:'',
                PROXY_PORT:'',
                PARENT_FLG:1,
                CHILD_NUM:0,
                ROOM_ID:''
            },
            postItem2:{
                AUTH_TOKEN:'',
                EXPIRATION_DATE:'',
                REF_TOKEN:'',
                SELLER_ID:'',
                USER_ID:'',
                UUID:''
            },
            type:'セラーID一覧',
            tmpSellerIdList:[],
            sellerIdList:[],
            currentPage: 1,
            perPage: 20,
            currentPage2: 1,
            perPage2: 20
        }
  },
    components: {
        "vuejs-paginate": VueJsPaginate,
    },
  methods:{
    typeChange(){
        let vm = this;
        vm.type= vm.type =='セラーID一覧'?'ユーザー作成':'セラーID一覧'
        if(vm.sellerIdList.length == 0){
            mLoginRepository.methods.Set({
            TYPE:'sellerIdList'
        }).then(res=>{
            if(res.data.length > 0){
                vm.sellerIdList = res.data;
                vm.tmpSellerIdList = res.data;
            }
        })
        }
    },
    getLoginInfo(item){
        let vm = this;
        var id = vm.postItem2.USER_ID;
        mLoginRepository.methods.Set({
            TYPE:'serch',
            USER_ID:vm.postItem2.USER_ID
        }).then(res=>{
            if(res.data.length > 0){
            vm.postItem2 = res.data[0];

            }
            console.log(vm.postItem2);
        })
    },
    loginOpen(item){
        var vm = this;
        mLoginRepository.methods.Set({
            TYPE:'child',
            USER_ID:item.USER_ID
        }).then(res=>{
            vm.loginSetUserList = res.data;
        })
        
    },

    loginSet(){
        let vm = this;
        mLoginRepository.methods.Set(vm.postItem2).then(res=>{
            this.$swal("メルカリログイン設定をしました", {
                icon: "success",
            }).then(res=>{vm.$functions.reload(vm)});
        })
    },
    serch(){
        let vm = this;
        vm.tmpUserList = [...vm.userList];
        vm.tmpSellerIdList = [...vm.sellerIdList];
        if(vm.serchItem.name){
            //名前フィルター
            vm.tmpUserList = vm.tmpUserList.filter(x=> x.USER_NAME.indexOf(vm.serchItem.name) != -1);
        }
        if(vm.serchItem.id){
            //名前フィルター
            vm.tmpUserList = vm.tmpUserList.filter(x=> x.USER_ID == vm.serchItem.id);
        }
        if(vm.serchItem.seller_id){
            //名前フィルター
            vm.tmpSellerIdList = vm.tmpSellerIdList.filter(x=> x.SELLER_ID == vm.serchItem.seller_id);
        }
    },
    clear(){
        let vm = this;
        vm.tmpUserList = [...vm.userList]
        for(var i=0; i< this.tmpUserList.length; i++){
            this.tmpUserList[i].display =true;
        }
        this.serchItem ={};
    },
    paginateClickCallback (pageNum) {
        this.currentPage = Number(pageNum);
    },
    paginateClickCallback2 (pageNum) {
        this.currentPage2 = Number(pageNum);
    },
    stop(item){
        let vm = this;
        vm.$functions.swAlert(vm, "warning", "このユーザーを停止してよろしいですか？", `ユーザー名:${item.USER_NAME}`)
        .then((btn) => {
            if (btn.isConfirmed) {
                var postItem = {...item};
                delete postItem.display;
                userRepository.methods.stop(postItem)
                .then(res=>{
                
                    this.$swal("停止しました", {
                        icon: "success",
                    }).then(res=>{vm.$functions.reload(vm)});
                })
            }
        });
    },
    restart(item){
        let vm = this;
        vm.$functions.swAlert(vm, "warning", "このユーザーを再開してよろしいですか？", `ユーザー名:${item.USER_NAME}`)
        .then((btn) => {
            if (btn.isConfirmed) {
                var postItem = {...item};
                delete postItem.display;
                userRepository.methods.restart(postItem)
                .then(res=>{

                    this.$swal("再開しました", {
                        icon: "success",
                    }).then(res=>{vm.$functions.reload(vm)});
                })
            }
        });
    },
      remove(item, index){
        let vm = this;
        vm.$functions.swAlert(vm, "warning", "このユーザーを削除してよろしいですか？", `ユーザー名:${item.USER_NAME}`)
        .then((btn) => {
            if (btn.isConfirmed) {
                var postItem = {...item};
                postItem.DEL_FLG = 1;
                delete postItem.display;
                userRepository.methods.change(postItem)
                .then(res=>{
                    vm.userList.splice(index -1,1);
                    this.$swal("削除しました", {
                        icon: "success",
                    }).then(res=>{vm.$functions.reload(vm)});
                })
            }
        });
      },
      change(index){
          let vm = this;
          var item = vm.tmpUserList[index];
          if(!vm.chgUserValidAll(vm.$v.tmpUserList.$each[index])) return;
          vm.$functions.swAlert(vm, "warning", "このユーザーを更新してよろしいですか？", `ユーザー名:${item.USER_NAME}`)
            .then((btn) => {
            if (btn.isConfirmed) {
                var postItem = {...item};
                delete postItem.display;
                delete postItem.CONNECT_NUM;
                userRepository.methods.change(postItem)
                .then(res=>{
                    this.$swal("更新しました", {
                        icon: "success",
                    }).then(res=>{vm.$functions.reload(vm)});
                })
            }
        });
          
      },
      create(){
            let vm = this;
            if(!vm.crtUserValidAll()) return;
            vm.isModal = false;
            userRepository.methods.Create(vm.postItem)
            .then(res=>{
                vm.init();
                vm.$swal(
                'ユーザーを作成しました',
                '',
                'success'
            ).then(res=>{vm.$functions.reload(vm)});
            });
        },
      returnPage(){
          let vm = this;
            vm.$router.back();
        },
        init(){
            let vm =this;
            vm.userInfo = vm.$functions.getSStorage('userInfo');
            userRepository.methods.getAdmin()
            .then(res=>{
                var data = res.data;
                for(var i=0; i< data.length; i++){
                    data[i].tmpPassword = '';
                    data[i].display = true;
                    data[i].CONNECT_NUM = data[i].CONNECT_NUM == null ? 0: data[i].CONNECT_NUM;
                }
                vm.tmpUserList = data;
                
                vm.userList = data;
            })
            .catch(err=>{
                console.log(err);
            })
        },
        valid(v, name, regexType){
            check.checkStr(v, name, regexType);
        },
        chgUserValidAll(item){
            let vm = this;
            try{
                if(!check.checkStr(item.CHILD_NUM, '子契約数'))  throw 'userName';
            }catch(e){
                vm.tmp = 'tmp';
                return false;
            }
            return true;
        },
        /**
         * 全てのバリデーションチェックを実行し、エラーメッセージを設定します
         */
        crtUserValidAll(){
            let vm = this;
            try{
                if(!check.checkStr(vm.$v.postItem.USER_NAME, 'ユーザー名'))  throw 'userName';
                if(!check.checkStr(vm.$v.postItem.USER_ID, 'ユーザーID')) throw 'userId';
                if(!check.checkStr(vm.$v.postItem.PASSWORD, 'パスワード')) throw 'password';
                if(!check.checkStr(vm.$v.postItem.CHILD_NUM, '子契約数雨')) throw 'childNum';
            }catch(e){
                vm.tmpLogin = 'tmp';
                return false;
            }
            return true;
        },
  },
  computed:{
        getPaginateCount: function () {
            return Math.ceil(this.tmpUserList.length / this.perPage);
        },
        getItems () {
            if(this.tmpUserList.length == 0) return;
            let start = (this.currentPage - 1) * this.perPage;
            let end = this.currentPage * this.perPage;
            return this.tmpUserList.slice(start, end);
        },
        getPaginateCount2: function () {
            return Math.ceil(this.tmpSellerIdList.length / this.perPage);
        },
        getItems2 () {
            if(this.tmpSellerIdList.length == 0) return;
            let start = (this.currentPage2 - 1) * this.perPage2;
            let end = this.currentPage2 * this.perPage2;
            return this.tmpSellerIdList.slice(start, end);
        }
    },
  created:function(){
      let vm =this;
      vm.init();
  },
  validations: {
      //新規ユーザ作成
      postItem:{
          USER_ID:{
              required,
              maxLength:maxLength(8),
              err:(val)=> check.HankakuEisuu(val)
          },
          USER_NAME:{
              required
          },
          PASSWORD:{
              required
          },
          CHILD_NUM:{
              required
          }
      },
      //テーブル編集
      tmpUserList:{
          $each:{
              tmpPassword:{
                err:(val)=> check.HankakuEisuu(val)
              },
              CHILD_NUM:{
                  required,
                  err:(val)=> check.HankakuSuuzi(val)
              }
          }
      }
  }
}
</script>

<style scoped lang="scss">
    @import "../style/menu.scss";
    @import "../style/list.scss";
    @import "../style/userSetting.scss";
    @import "../style/login.scss";
    
</style>